/* Product page service cards (snippets/fs-pdp-facts.liquid, mode 'cards') – behaves like the live WP page:
   from 990px a card opens its dialog (Esc, the close button or a click on the dimmed backdrop closes it);
   under 990px an accordion, one panel open at a time, 300ms height animation, chevron turns. */
if (!customElements.get('fs-services')) {
  customElements.define(
    'fs-services',
    class FsServices extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', (e) => {
          const open = e.target.closest('[data-svc-open]');
          if (open) {
            const dlg = document.getElementById(open.dataset.svcOpen);
            if (dlg && typeof dlg.showModal === 'function') {
              this.opener = open;
              dlg.showModal();
            }
            return;
          }
          if (e.target.closest('[data-svc-close]')) return void e.target.closest('dialog').close();
          // a click on the dialog element itself (not its content) = a click on the backdrop
          if (e.target instanceof HTMLDialogElement) return void e.target.close();
          const toggle = e.target.closest('.fs-svca__toggle');
          if (toggle) this.toggle(toggle);
        });
        this.querySelectorAll('dialog').forEach((dlg) =>
          dlg.addEventListener('close', () => this.opener && this.opener.focus({ preventScroll: true }))
        );
      }

      toggle(btn) {
        const opening = btn.getAttribute('aria-expanded') !== 'true';
        this.querySelectorAll('.fs-svca__toggle[aria-expanded="true"]').forEach((b) => b !== btn && this.set(b, false));
        this.set(btn, opening);
      }

      set(btn, open) {
        const panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        btn.setAttribute('aria-expanded', String(open));
        btn.parentElement.classList.toggle('is-open', open);
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (open) panel.hidden = false;
        if (reduce) return void (panel.hidden = !open);
        const from = open ? 0 : panel.scrollHeight;
        const to = open ? panel.scrollHeight : 0;
        panel.style.height = `${from}px`;
        panel.offsetHeight; // reflow so the transition starts from `from`
        panel.style.height = `${to}px`;
        clearTimeout(panel.fsTimer);
        panel.fsTimer = setTimeout(() => {
          panel.style.height = '';
          if (!open) panel.hidden = true;
        }, 300);
      }
    }
  );
}
